import { ScrollView, StyleSheet } from "react-native";

import { Block, SvgIcon, Typography, palette, spacing } from "@stepapp/ui";
import { useTranslation } from "react-i18next";
import { useContactDetails } from "../src/hooks";

export default function MaintenanceScreen() {
  const { t } = useTranslation();
  const { Email, LandingPageUrl } = useContactDetails();

  return (
    <ScrollView style={styles.container}>
      <SvgIcon name="warning" size={24} style={styles.warningIcon} />

      <Block alignCenter justifyCenter paddingVertical={3.5}>
        <Typography center type="white" variant="newH1">
          {t("screens.maintenance.maintenanceBreak")}
        </Typography>

        <Block marginTop={4}>
          <Typography center type="white" variant="body">
            {t("screens.maintenance.maintenanceInProgress")}
          </Typography>
        </Block>
        <Block marginTop={4}>
          <Typography center type="white" variant="body">
            {t("screens.maintenance.maintenanceContactInfo", {
              landingPageUrl: LandingPageUrl,
              supportEmail: Email,
            })}
          </Typography>
        </Block>
      </Block>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  warningIcon: {
    alignSelf: "center",
  },
  container: {
    backgroundColor: palette.primary.accent,
    paddingHorizontal: spacing.unit * 4,
    paddingTop: spacing.unit * 15,
  },
});
